import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/layout/layout.component';
import { AuthGuard } from './core/guards/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/home/home.component').then(m => m.HomeComponent),
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./features/products/products.component').then(m => m.ProductsComponent),
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/profile.component').then(m => m.ProfileComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'free-test',
        loadComponent: () =>
          import('./features/free-test/free-test-instructions/free-test-instructions.component').then(m => m.FreeTestInstructionsComponent),
      },
      {
        path: 'free-test-instructions',
        loadComponent: () =>
          import('./features/free-test/free-test-instructions/free-test-instructions.component').then(m => m.FreeTestInstructionsComponent),
      },
      {
        path: 'certifications/:certId/tests',
        loadComponent: () =>
          import('./features/test-selection/test-selection.component').then(m => m.TestSelectionComponent),
      },
      {
        path: 'exam',
        loadComponent: () =>
          import('./shared/exam/exam-player/exam-player.component').then(m => m.ExamPlayerComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'exam-taker/:examId',
        loadComponent: () =>
          import('./exam/exam-taker/exam-taker.component').then(m => m.ExamTakerComponent),
        canActivate: [AuthGuard]
      },
      {
        path: 'auth/login',
        loadComponent: () =>
          import('./auth/login/login.component').then(m => m.LoginComponent),
      },
      {
        path: 'login',
        redirectTo: 'auth/login',
        pathMatch: 'full'
      },
      {
        path: 'cookies',
        loadComponent: () =>
          import('./features/cookie-policy/cookie-policy.component').then(m => m.CookiePolicyComponent),
      },
      // Protected routes that require authentication
      {
        path: 'submissions',
        loadComponent: () =>
          import('./features/submissions/submissions.component').then(m => m.SubmissionsComponent),
        canActivate: [AuthGuard]
      }
    ],
  }
];
